import * as React from "react";
 
// importing material UI components
import { useState } from 'react';
import AudienceTable from './AudienceTable';
import Container from '@mui/material/Container';

const Audience = (props) => {
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="App">
      <Container maxWidth={false} sx={{bgcolor:'#FAFAFA', p:3}}>
        <>
          <AudienceTable 
            refreshkey={refreshKey}
            updateRefreshKey={setRefreshKey}
            onNavigate={props.onNavigate}
          />
        </>
      </Container>

    </div>
  );
}
export default Audience;
